export function PlatformLink(
  id: string,
  platform: string,
  postURL: string
): string {
  if (platform === 'Reddit') {
    return `https://reddit.com${postURL}`
  } else if (platform === 'Youtube') {
    return `http://www.youtube.com/watch?v=${id}`
  } else if (platform === 'Twitter') {
    return `https://twitter.com/wgervais/status/${id}`
  } else if (platform === 'Facebook') {
    return 'https://www.facebook.com'
  } else if (platform === 'Instagram') {
    return postURL
  } else if (platform === 'TikTok') {
    return postURL
  } else {
    return ''
  }
}

export const DEFAULT_URL_LINK =
  'https://media.istockphoto.com/id/1147544806/vector/no-thumbnail-image-vector-graphic.jpg?s=170667a&w=0&k=20&c=-r15fTq303g-Do1h-F1jLdxddwkg4ZTtkdQK1XP2sFk='

export const DEFAULT_AVATAR_URL =
  'https://media.istockphoto.com/id/1298261537/vector/blank-man-profile-head-icon-placeholder.jpg?s=612x612&w=is&k=20&c=4LIPO37HWnx_3hmtrtMY8_yKgwh6LLpABfkuEWdD8Uw='
